import type { DocPageContent } from '../docs-content'

const page = {
  order: 7,
  slug: 'editing-tools',
  title: '编辑工具',
  description:
    '选择、剃刀、修整、滑移、滑动、速度拉伸，以及波纹与滚动修剪行为。',
  category: '核心编辑',
  related: ['timeline', 'keyboard-shortcuts', 'properties'],
  sections: [
    {
      title: '核心工具',
      blocks: [
        {
          kind: 'table',
          headers: ['工具', '按键', '用途'],
          rows: [
            ['选择', '`V`', '选择、移动并排列片段。'],
            ['修整编辑', '`T`', '拖动片段边缘以改变其开始或结束位置。'],
            ['剃刀', '`C`', '在点击处切割片段。'],
            ['速度拉伸', '`R`', '通过改变播放速度来改变时长。'],
            ['滑移', '`Y`', '在不移动片段的情况下改变其内部源帧。'],
            ['滑动', '`U`', '移动片段的同时调整相邻的切口。'],
          ],
        },
      ],
    },
    {
      title: '修整行为',
      blocks: [
        {
          kind: 'list',
          items: [
            '**波纹**修剪会改变一次编辑并推移其后所有素材，因此总时长会变化。',
            '**滚动**修剪会移动两个相邻片段之间的切口，整体时长不变。',
            '**滑移**编辑会在不移动片段或其相邻片段的情况下，改变片段内显示的源帧。',
            '**滑动**编辑会沿轨道移动一个片段，同时自动调整相邻的切口。',
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '波纹和滚动是**修整编辑**工具的行为，而非拥有各自快捷键的独立工具。',
        },
      ],
    },
    {
      title: '保持片段同步',
      blocks: [
        {
          kind: 'list',
          items: [
            '**链接选择**会使视频片段及其音频一起移动；用 `Shift+L` 切换。',
            '当某个关系需要变更时，用 `Ctrl+Alt+L` 链接片段，用 `Alt+Shift+L` 取消链接。',
            '轨道上的**同步锁定**会在波纹式编辑期间保持时序对齐。',
          ],
        },
      ],
    },
    {
      title: '结构性编辑',
      blocks: [
        {
          kind: 'list',
          items: [
            '用 `Shift+F` 在播放头处插入一个**冻结帧**，以定格单帧。',
            '将一段片段编组为一个**复合片段**，以复用或简化一个繁杂的段落，或将其作为**序列**标签页打开，作为独立时间轴编辑。',
            '使用**Bento 布局**对话框，将选中的可视片段排列为一个结构化网格。',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
